"use strict";

document.addEventListener("DOMContentLoaded", function () {
  const collapsibleWrap = document.querySelector(".gr-collapsible-wrap");
  if (collapsibleWrap) {
    const detailsElements = collapsibleWrap.querySelectorAll(".gr-details");
    detailsElements.forEach(details => {
      details.addEventListener("toggle", function () {
        if (details.hasAttribute("open")) {
          detailsElements.forEach(otherDetails => {
            if (otherDetails !== details && otherDetails.hasAttribute("open")) {
              otherDetails.removeAttribute("open");
            }
          });
        }
      });

      // Додаємо обробник кліку на елемент .gr-details
      details.addEventListener("click", function (event) {
        // Перевіряємо, чи клік НЕ був на <summary>
        if (!event.target.closest("summary") && details.hasAttribute("open")) {
          details.removeAttribute("open");
        }
      });
    });
  }
});